import type { FaqItem } from 'types/section'

const faqEngagement: FaqItem = {
  question: 'Y a-t-il un engagement de durée ?',
  answer: 'L\'abonnement mensuel est sans engagement de durée : il est tacitement reconduit chaque mois et peut être résilié à tout moment, avec effet à la fin du mois calendaire en cours, sans préavis minimal ni frais. L\'abonnement annuel est reconduit tacitement d\'année en année et se résilie moyennant un préavis de trois mois avant son échéance annuelle. Dans les deux cas, vous pouvez ajouter ou retirer des écrans à tout moment. Pour les déploiements multi-sites ou en volume, des conditions particulières peuvent être convenues lors de la souscription.'
}

const faqPayment: FaqItem = {
  question: 'Quels moyens de paiement acceptez-vous ?',
  answer: 'Nous acceptons les cartes bancaires (Visa, Mastercard, American Express) et les virements bancaires pour toutes les formules. Le moyen de paiement applicable est confirmé lors de la souscription.'
}

const faqExistingScreens: FaqItem = {
  question: 'Puis-je utiliser mes écrans existants ?',
  answer: 'Oui. Si votre écran peut afficher un navigateur web (Smart TV, ordinateur, tablette), il est compatible. Sinon, notre box Live Display permet de rendre n\'importe quel écran connecté.'
}

const faqStartTime: FaqItem = {
  question: 'Combien de temps faut-il pour démarrer ?',
  answer: 'Vous pouvez avoir votre premier diaporama en ligne en moins d\'une heure. La création de contenu est intuitive et la mise en ligne sur vos écrans se fait en quelques clics.'
}

const faqRemoteUpdate: FaqItem = {
  question: 'Puis-je modifier mes contenus à distance ?',
  answer: 'Oui. Toutes les modifications sont diffusées à distance et appliquées instantanément sur vos écrans, sans avoir à vous déplacer ni à relancer les appareils.'
}

const faqBoxHowItWorks: FaqItem = {
  question: 'Comment fonctionne la box Live Display ?',
  answer: 'C\'est une petite box, assemblée en Suisse, à brancher sur votre écran. Une fois connectée à internet, elle reçoit automatiquement le contenu que vous diffusez depuis votre compte.'
}

const faqBoxWifi: FaqItem = {
  question: 'Comment connecter la box au Wi-Fi ?',
  answer: 'Branchez un câble réseau, ou laissez-vous guider : sans connexion, la box affiche un QR code à l\'écran. Scannez-le avec votre téléphone, choisissez votre réseau Wi-Fi et saisissez son mot de passe. La box se connecte et démarre la diffusion.'
}

const faqBoxUpdates: FaqItem = {
  question: 'Comment la box se met-elle à jour ?',
  answer: 'Toute seule. Pendant la journée, elle prépare les nouveautés sans interrompre la diffusion, puis les installe la nuit. Vous profitez des dernières améliorations sans rien faire, et elles sont comprises dans votre abonnement.'
}

const faqBoxRemoteActions: FaqItem = {
  question: 'Puis-je agir sur ma box à distance ?',
  answer: 'Oui. Depuis votre compte, vous pouvez identifier l\'écran, voir une capture de ce qu\'il diffuse, recharger vos images et vidéos ou redémarrer la box en un clic, où qu\'elle soit installée. Vous suivez aussi son état en continu, pour une diffusion en toute sérénité.'
}

const faqScreenOff: FaqItem = {
  question: 'Mon écran s\'éteint la nuit. Comment ça se passe ?',
  answer: 'Vous pouvez configurer un diaporama de veille différent pour les heures creuses, ou laisser votre écran s\'éteindre selon ses propres réglages. La diffusion reprend automatiquement.'
}

const faqBilling: FaqItem = {
  question: 'Comment fonctionne la facturation par écran ?',
  answer: 'L\'abonnement est mensuel : vous payez chaque mois en fonction du nombre d\'écrans configurés sur votre compte, qu\'ils soient connectés ou non à ce moment-là. Ajoutez ou retirez un écran à tout moment, la facturation s\'ajuste automatiquement. Votre premier mois est offert : la facturation ne démarre qu\'à partir du deuxième mois.'
}

const faqTrialAfter: FaqItem = {
  question: 'Que se passe-t-il après le mois d\'essai gratuit ?',
  answer: 'À l\'issue du mois offert, votre compte bascule sur la formule choisie. Un abonnement mensuel peut être résilié à tout moment, pour la fin du mois en cours ; un abonnement annuel se résilie moyennant un préavis de trois mois avant l\'échéance annuelle. Aucune carte bancaire n\'est requise pour démarrer l\'essai.'
}

const faqMultiSite: FaqItem = {
  question: 'Quelle formule choisir pour une enseigne avec plusieurs points de vente ?',
  answer: 'La formule Sur-mesure est conçue pour les déploiements multi-sites. Elle inclut un tarif dégressif au volume, un interlocuteur dédié et la possibilité de centraliser des contenus communs à toute l\'enseigne avec la composition de diaporamas.'
}

const faqBoxOptional: FaqItem = {
  question: 'La box Live Display est-elle obligatoire ?',
  answer: 'Non, vous pouvez utiliser n\'importe quel écran capable d\'afficher un navigateur web. La box est recommandée pour un affichage permanent et fiable, sans avoir à dédier un ordinateur ni à surveiller le bon fonctionnement de l\'écran.'
}

const faqChangeFormula: FaqItem = {
  question: 'Puis-je changer de formule plus tard ?',
  answer: 'Oui, vous pouvez passer d\'une formule à une autre à tout moment, sans interruption de service. L\'ajustement de facturation est calculé au prorata du mois en cours.'
}

const faqQuote: FaqItem = {
  question: 'Comment obtenir un devis personnalisé ?',
  answer: 'Demandez un devis depuis la page dédiée en précisant le nombre d\'écrans et de sites concernés. Nous revenons rapidement avec une proposition adaptée à votre volume et à vos besoins.'
}

const faqBoxOrder: FaqItem = {
  question: 'Comment se commande la box ?',
  answer: 'Demandez un devis via la page dédiée en indiquant le nombre de box souhaitée. Nous revenons vers vous rapidement avec un devis précis et des conditions adaptées au volume.'
}

const faqBoxPrice: FaqItem = {
  question: 'Quel est le tarif exact ?',
  answer: 'Le tarif est dégressif selon le nombre total d\'écrans déployés, avec un prix plancher de Fr. 199.– par box. Pour un déploiement multi-sites, le tarif est étudié au cas par cas.'
}

const faqBoxOffline: FaqItem = {
  question: 'La box fonctionne-t-elle sans internet ?',
  answer: 'Une connexion internet est nécessaire pour recevoir vos contenus et les mises à jour. La box peut continuer à afficher le dernier contenu reçu en cas de coupure ponctuelle.'
}

const faqBoxSubscription: FaqItem = {
  question: 'Faut-il un abonnement en plus de la box ?',
  answer: 'Oui, chaque écran configuré nécessite un abonnement Live Display selon la formule choisie. La box est facturée à part en une fois, l\'abonnement mensuel couvre le service de diffusion.'
}

const faqBoxCompatible: FaqItem = {
  question: 'Quels écrans sont compatibles ?',
  answer: 'Tous les écrans modernes : téléviseurs, écrans professionnels, moniteurs informatiques. Il vous suffit d\'une alimentation à proximité et d\'une connexion internet.'
}

const faqBoxWarranty: FaqItem = {
  question: 'La box est-elle garantie ?',
  answer: 'Oui, chaque box bénéficie d\'une garantie commerciale de 24 mois à compter de la livraison, couvrant tout défaut de conformité ou vice caché dans des conditions normales d\'utilisation. En cas de panne, nous réparons ou remplaçons la box défectueuse.'
}

const faqScreensChoice: FaqItem = {
  question: 'Quel type d\'écran professionnel choisir pour mon activité ?',
  answer: 'Cela dépend de l\'emplacement et de l\'objectif. Un écran vitrine haute luminosité s\'impose derrière une vitre exposée au soleil, un moniteur professionnel 24h/24 convient à un accueil ou une salle d\'attente, un mur d\'écrans ou un panneau LED grand format habille un hall ou un espace de vente, et une borne tactile permet l\'interaction avec vos visiteurs. Nous vous conseillons sur le format, la dalle et la fixation adaptés à votre lieu, et notre partenaire Beecolor réalise l\'installation.'
}

const faqScreensBuyRent: FaqItem = {
  question: 'Peut-on acheter ou louer les écrans d\'affichage ?',
  answer: 'Les deux sont possibles. Vous pouvez acheter vos écrans professionnels, bornes tactiles et totems vidéo, ou opter pour une formule adaptée à votre projet. Les écrans sont fournis, posés et installés partout en Suisse par notre partenaire Beecolor, puis gérés à distance depuis le logiciel Live Display. Le tarif des écrans est établi sur devis selon les typologies et les quantités.'
}

const faqScreensInstall: FaqItem = {
  question: 'L\'installation des écrans est-elle prise en charge ?',
  answer: 'Oui. Live Display coordonne le projet de bout en bout — étude du besoin, planification de l\'intervention et mise en service — et notre partenaire Beecolor réalise la fourniture, la pose et la fixation des écrans sur site. Vous gardez un interlocuteur unique, du devis au service après-vente.'
}

const faqScreensArea: FaqItem = {
  question: 'Intervenez-vous partout en Suisse ?',
  answer: 'Oui. La fourniture, la pose et la maintenance sont assurées dans toute la Suisse. Live Display est basé dans le canton de Vaud et intervient en priorité en Suisse romande, avec un support en français.'
}

const faqScreensDelay: FaqItem = {
  question: 'Quel est le délai entre le devis et la mise en service ?',
  answer: 'Le délai dépend des écrans retenus et de la complexité de la pose. Après validation du devis, nous planifions l\'intervention avec vous et confirmons une date de mise en service. Un écran seul se pose en une intervention, tandis qu\'un mur d\'écrans ou une enseigne lumineuse demande une préparation supplémentaire.'
}

const faqScreensWarranty: FaqItem = {
  question: 'Les écrans professionnels sont-ils garantis ?',
  answer: 'Oui. Les écrans professionnels bénéficient de la garantie constructeur, généralement plus étendue que celle d\'un téléviseur grand public car ils sont conçus pour un fonctionnement continu. La durée exacte dépend du modèle retenu et figure sur votre devis.'
}

const faqScreensSubscription: FaqItem = {
  question: 'Les écrans sont-ils inclus dans l\'abonnement Live Display ?',
  answer: 'Non, les deux sont indépendants. Les écrans, bornes tactiles et totems sont facturés à l\'achat, sur devis. L\'abonnement Live Display couvre le logiciel et la diffusion, facturé par écran configuré sur votre compte.'
}

const faqScreensSignage: FaqItem = {
  question: 'Proposez-vous aussi de la signalétique et de l\'impression grand format ?',
  answer: 'Oui. Au-delà des écrans, notre partenaire réalise l\'ensemble de votre communication visuelle : enseignes et habillage de vitrines, vitrophanie et films dépolis, impression grand format sur panneaux Dibond, Forex ou Plexiglas, marquage publicitaire de véhicules, PLV et stands d\'exposition, ainsi que la signalétique d\'orientation intérieure et extérieure.'
}

const faqScreensSoftware: FaqItem = {
  question: 'Le logiciel Live Display fonctionne-t-il avec ces écrans ?',
  answer: 'Oui. Tous les écrans installés sont gérés à distance et en temps réel depuis le logiciel Live Display. Vous composez vos diaporamas, planifiez vos contenus et mettez à jour vos écrans en quelques clics, qu\'il s\'agisse d\'un écran vitrine, d\'un mur d\'écrans, d\'une borne tactile ou d\'un totem vidéo.'
}

export const faqScreensItems: FaqItem[] = [
  faqScreensChoice,
  faqExistingScreens,
  faqScreensBuyRent,
  faqScreensSubscription,
  faqScreensInstall,
  faqScreensArea,
  faqScreensDelay,
  faqScreensWarranty,
  faqScreensSignage,
  faqScreensSoftware
]

const faqWhatIsSignage: FaqItem = {
  question: 'Qu\'est-ce que l\'affichage dynamique ?',
  answer: 'L\'affichage dynamique, ou digital signage, consiste à diffuser des contenus multimédias — photos, vidéos, messages, menus — sur un ou plusieurs écrans, à distance et en temps réel. Il remplace l\'affiche imprimée par un écran que l\'on met à jour en quelques clics depuis un logiciel.'
}

const faqWhatIsLiveDisplay: FaqItem = {
  question: 'Qu\'est-ce que Live Display ?',
  answer: 'Live Display est une solution suisse d\'affichage dynamique qui réunit un logiciel, une box HDMI 4K et des écrans professionnels. Vous créez vos diaporamas, planifiez leur diffusion et mettez à jour tous vos écrans à distance, depuis un seul compte.'
}

const faqNoSkills: FaqItem = {
  question: 'Faut-il des compétences techniques pour l\'utiliser ?',
  answer: 'Non. L\'éditeur fonctionne en glisser-déposer, sans connaissance technique ni en design. La plupart des écrans s\'utilisent via un simple navigateur web ; pour un usage permanent, la box Live Display est prête à l\'emploi.'
}

const faqWhoFor: FaqItem = {
  question: 'À qui s\'adresse l\'affichage dynamique ?',
  answer: 'À tout lieu où un écran communique : restaurants, commerces, cabinets médicaux, agences, salles de sport, entreprises, écoles ou collectivités. Le contenu s\'adapte à chaque secteur — menu digital, écran vitrine, salle d\'attente ou communication interne.'
}

const faqVsTelevision: FaqItem = {
  question: 'Quelle différence avec une simple télévision ?',
  answer: 'Une télévision diffuse un flux ; l\'affichage dynamique diffuse vos propres contenus, planifiés et modifiables à distance. Avec Live Display, vous décidez ce qui s\'affiche sur chaque écran et à quelle heure, et vous le changez en temps réel depuis votre compte.'
}

const faqWhatContent: FaqItem = {
  question: 'Quels contenus peut-on diffuser ?',
  answer: 'Photos, vidéos, textes, menus, promotions, horaires, actualités ou données de votre entreprise. Vous composez des diaporamas mêlant ces éléments et les organisez par écran et par plage horaire.'
}

export const faqHomeItems: FaqItem[] = [
  faqWhatIsSignage,
  faqWhatIsLiveDisplay,
  faqVsTelevision,
  faqWhatContent,
  faqNoSkills,
  faqWhoFor
]

export const faqPricingItems: FaqItem[] = [
  faqBilling,
  faqEngagement,
  faqTrialAfter,
  faqStartTime,
  faqMultiSite,
  faqBoxOptional,
  faqPayment,
  faqChangeFormula,
  faqQuote
]

export const faqBoxItems: FaqItem[] = [
  faqBoxHowItWorks,
  faqBoxCompatible,
  faqBoxWifi,
  faqBoxOffline,
  faqBoxUpdates,
  faqBoxRemoteActions,
  faqScreenOff,
  faqRemoteUpdate,
  faqBoxSubscription,
  faqBoxOrder,
  faqBoxPrice,
  faqBoxWarranty
]

const faqEditorVideo: FaqItem = {
  question: 'Peut-on diffuser des vidéos YouTube sur un écran d\'affichage dynamique ?',
  answer: 'Oui. Collez le lien de votre vidéo YouTube ou Vimeo dans une page : elle est diffusée sur vos écrans sans téléchargement ni conversion. Vous pouvez aussi importer vos propres vidéos dans la médiathèque.'
}

const faqEditorCountdown: FaqItem = {
  question: 'Comment afficher un compte à rebours avant une promotion ou un événement ?',
  answer: 'Ajoutez un compte à rebours à votre page, choisissez la date et l\'heure de fin, puis le style : chiffres, tuiles ou texte. Les jours, heures et minutes restants défilent en direct sur vos écrans.'
}

const faqEditorQrCode: FaqItem = {
  question: 'Peut-on afficher un QR code sur un écran ?',
  answer: 'Oui. Saisissez l\'adresse de votre site, un numéro de téléphone ou une adresse email : le QR code est créé aussitôt et vos visiteurs n\'ont plus qu\'à le scanner avec leur téléphone.'
}

const faqEditorAnimations: FaqItem = {
  question: 'Peut-on animer les textes et les images d\'une page ?',
  answer: 'Oui. Chaque élément peut apparaître et disparaître avec une animation : fondu, glissement, zoom ou machine à écrire pour les textes. Vous choisissez aussi la vitesse, sans aucune compétence technique.'
}

const faqEditorOnDemand: FaqItem = {
  question: 'Pouvez-vous développer un contenu sur mesure ?',
  answer: 'Oui. Réseaux sociaux, agenda, horaires des transports ou chiffres clés : décrivez-nous votre besoin, nous étudions avec vous la meilleure façon de l\'afficher sur vos écrans.'
}

export const faqEditorItems: FaqItem[] = [
  faqEditorVideo,
  faqEditorCountdown,
  faqEditorQrCode,
  faqEditorAnimations,
  faqNoSkills,
  faqEditorOnDemand
]

const faqContactChannels: FaqItem = {
  question: 'Comment contacter l\'équipe Live Display ?',
  answer: `Par téléphone au ${companyContactPhone}, ${companyOpeningHours.charAt(0).toLowerCase()}${companyOpeningHours.slice(1)}, ou à tout moment via le formulaire de contact. Nous répondons en français et vous rappelons volontiers si vous préférez un échange de vive voix.`
}

const faqContactResponseTime: FaqItem = {
  question: 'Sous quel délai obtenez-vous une réponse ?',
  answer: 'Nous répondons sous 48 heures ouvrées à toute demande envoyée par le formulaire. Pour une question urgente, le téléphone reste le canal le plus rapide durant nos heures d\'ouverture.'
}

const faqContactLanguage: FaqItem = {
  question: 'Dans quelle langue est assuré le support ?',
  answer: 'Le support est assuré en français par notre équipe basée en Suisse, dans le canton de Vaud. Nous accompagnons nos clients dans toute la Suisse, avec une priorité pour la Suisse romande.'
}

const faqContactOnboarding: FaqItem = {
  question: 'Proposez-vous un accompagnement à la prise en main ?',
  answer: 'Oui. L\'accompagnement à la prise en main est inclus : nous configurons votre premier diaporama avec vous et restons disponibles pour vos questions. Pour tester le logiciel sur vos écrans, demandez une démo gratuite d\'un mois.'
}

const faqContactSalesVsSupport: FaqItem = {
  question: 'Comment tester le logiciel ou obtenir un devis ?',
  answer: 'Pour tester Live Display, utilisez la page démo : un mois offert, sans engagement ni carte bancaire. Pour un déploiement multi-sites, une commande de box en volume ou des écrans professionnels, passez par la page devis afin d\'obtenir une proposition chiffrée adaptée à votre projet.'
}

const faqTrialFree: FaqItem = {
  question: 'L\'essai est-il vraiment gratuit et sans engagement ?',
  answer: 'Oui. Le premier mois est entièrement offert, sans carte bancaire ni engagement de durée. Vous accédez à toutes les fonctionnalités et diffusez vos contenus sur vos écrans pendant un mois complet, librement.'
}

const faqTrialNoCard: FaqItem = {
  question: 'Faut-il une carte bancaire pour démarrer l\'essai ?',
  answer: 'Non. Aucun moyen de paiement n\'est demandé pour ouvrir votre essai. Vous ne renseignez vos informations de facturation que si vous décidez de poursuivre à l\'issue du mois offert.'
}

const faqTrialContentKept: FaqItem = {
  question: 'Mes contenus sont-ils conservés après l\'essai ?',
  answer: 'Oui. Si vous poursuivez, votre compte bascule sur la formule choisie et vos diaporamas, médias et écrans configurés sont conservés à l\'identique, sans avoir à recommencer votre travail.'
}

const faqQuoteDelay: FaqItem = {
  question: 'Sous quel délai recevez-vous un devis ?',
  answer: 'Après réception de votre demande, nous revenons vers vous sous 48 heures ouvrées avec une première proposition. Le devis définitif est affiné avec vous selon le nombre de sites, d\'écrans et de box retenus.'
}

const faqQuoteFree: FaqItem = {
  question: 'Le devis est-il gratuit et sans engagement ?',
  answer: 'Oui. L\'établissement d\'un devis est gratuit et ne vous engage à rien. Il détaille le logiciel, la box et, le cas échéant, les écrans professionnels, afin que vous disposiez d\'une vision claire du budget avant toute décision.'
}

const faqDevisScreens: FaqItem = {
  question: 'Le devis peut-il inclure les écrans professionnels ?',
  answer: 'Oui. Au-delà du logiciel et de la box, le devis peut couvrir la fourniture d\'écrans professionnels : écrans vitrine haute luminosité, murs d\'écrans, bornes tactiles et totems vidéo. Ces écrans sont fournis, posés et installés partout en Suisse par notre partenaire Beecolor, puis gérés à distance depuis Live Display.'
}

const faqDevisInstall: FaqItem = {
  question: 'L\'installation des écrans est-elle comprise dans le devis ?',
  answer: 'Oui. Live Display coordonne votre projet de bout en bout — étude du besoin, planification et mise en service — et notre partenaire Beecolor assure la pose et la fixation des écrans sur site. Vous gardez un interlocuteur unique, du devis au service après-vente.'
}

export const faqContactItems: FaqItem[] = [
  faqContactChannels,
  faqContactResponseTime,
  faqContactLanguage,
  faqContactOnboarding,
  faqContactSalesVsSupport
]

export const faqDemoItems: FaqItem[] = [
  faqTrialFree,
  faqTrialNoCard,
  faqStartTime,
  faqExistingScreens,
  faqTrialAfter,
  faqTrialContentKept
]

export const faqDevisItems: FaqItem[] = [
  faqQuote,
  faqQuoteDelay,
  faqQuoteFree,
  faqMultiSite,
  faqBoxPrice,
  faqDevisScreens,
  faqDevisInstall,
  faqEngagement
]
